import { IRequestCommand } from "app/services/authentication/connection/iRequestCommand";
import { ErrorDetails } from "app/services/authentication/connection/interfaces/apiInterfaces";
import { CommandRequestType } from "app/services/authentication/connection/commandRequestType";
import { ICommandParameters } from "app/services/authentication/connection/iCommandParameters";
import { EmployeeDto } from "./getEmployeesGrants.command";

export class GetEmployeesWithoutGrantsCommand extends IRequestCommand<
  Array<EmployeeDto>,
  ErrorDetails,
  IGetEmployeesWithoutGrantsCommandParameters
> {
  override _commandType: CommandRequestType = CommandRequestType.GET;
  override _commandUrl = 'carriers/{carrierId}/serviceTypes/contractor/{contractorId}/employeesWithoutGrant';

  public override setParameters(parameters: IGetEmployeesWithoutGrantsCommandParameters) {
    if (parameters.serviceTypeId) {
      this._commandUrl = this._commandUrl + '?serviceTypeId='+parameters.serviceTypeId;
    } else {
      this._commandUrl = 'carriers/{carrierId}/serviceTypes/contractor/{contractorId}/employeesWithoutGrant';
    }
    this._commandUrl = this._commandUrl.replace(
        '{carrierId}',
        parameters.carrierId.toString()
    );
    this._commandUrl = this._commandUrl.replace(
        '{contractorId}',
        parameters.contractorId.toString()
    );
  }
}

export interface IGetEmployeesWithoutGrantsCommandParameters extends ICommandParameters {
  carrierId: string;
  serviceTypeId?: string;
  contractorId: string;
}